module.exports = [{
      plugin: require('../node_modules/gatsby-omni-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"enableListener":true,"preconnect":["https://fonts.googleapis.com","https://fonts.gstatic.com"],"web":[{"name":"Bitcount Grid Double","file":"https://fonts.googleapis.com/css2?family=Bitcount+Grid+Double:slnt,wght,CRSV,ELSH,ELXP@-8..0,100..900,0..1,0..100,0..100&display=swap"},{"name":"Press Start 2P","file":"https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap"}]},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
